import PropTypes from "prop-types"
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "../store";

// Loading component shown while redux-persist rehydrates state from localStorage.
const PersistLoading = () => (
    <div className="artote-preloader-wrapper">
        <img
            className="preloader-logo"
            src={process.env.PUBLIC_URL + "/assets/img/logo/logo.png"}
            alt="Artote"
        />
        <div className="artote-preloader">
            <span></span>
            <span></span>
        </div>
    </div>
);

const PersistProvider = ({ children }) => {
    return (
        <PersistGate loading={<PersistLoading />} persistor={persistor}>
            {children}
        </PersistGate>
    );
};

PersistProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export default PersistProvider;